import React from 'react';
interface Logo {
  name: string;
  image: string;
}
const logos: Logo[] = [{
  name: 'vacarya',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4pBQkoKNSEpV91spuQhCCd/67f7a8e9f47f978c9964dcc5_2.png'
}, {
  name: 'jinee',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hYiyJNcq9s5ziVhFobyfSj/67f7a8275a2ef82f19b8d3e9_1_%282%29.png'
}, {
  name: 'vertice labs',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/i6h3Pean2wSjVvwiRjJeJf/67f7a8e9a734cbad06a3972d_4.png'
}, {
  name: 'kazient',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pSerJvnTyv6HGzDKNxfmex/67f7a8e82a66c95867317bab_5_%282%29.png'
}, {
  name: 'dalal mehta law',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fvrCSWV2tqeuv2FaYjoeZa/67f7a7226805b1fccfc4149d_Nj-footer-Logo-e1744011770756_%281%29.png'
}];
export function LogoMarquee() {
  return <div className="relative w-full bg-[#0D0D0D] py-12 overflow-hidden" data-id="element-85">
      {/* Left fade */}
      <div className="absolute top-0 left-0 h-full w-24 bg-gradient-to-r from-[#0D0D0D] to-transparent z-10 pointer-events-none" data-id="element-86" />
      {/* Right fade */}
      <div className="absolute top-0 right-0 h-full w-24 bg-gradient-to-l from-[#0D0D0D] to-transparent z-10 pointer-events-none" data-id="element-87" />
      <div className="flex whitespace-nowrap animate-marquee gap-[80px] px-12" data-id="element-88">
        {[...logos, ...logos].map((logo, index) => <div key={`${logo.name}-${index}`} className="flex-shrink-0 flex items-center justify-center" data-id="element-89">
            <img src={logo.image} alt={logo.name} className="h-[160px] w-auto opacity-80 hover:opacity-100 transition duration-300 object-contain" data-id="element-90" />
          </div>)}
      </div>
    </div>;
}